import React, { useEffect } from "react";
import { auth, signInWithGoogle, loginInWithEmailAndPassword } from "./firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate, Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function Landing() {
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();
  useEffect(() => {
    if (loading) {
      return;
    }
    if (user) navigate("/dashboard");
  }, [user, loading]);
  return (
    <div className="m-5">
      <Row className="justify-content-md-center mb-4">
        <Col>
          <p>Bienvenidos a la Gran Recogida de Alimentos 2023</p>
        </Col>
      </Row>
      <Row className="justify-content-md-center">
        <Col lg="2">
          <Link to="/register" className="btn btn-primary">Regístrate</Link>
        </Col>
        <Col lg="2">
          <Link to="/login" className="btn btn-primary">Iniciar sesión</Link>
        </Col>
        <Col lg="3">
          <Button className="login__btn login__google" onClick={signInWithGoogle}>
                Inciar sesion con Google
          </Button>
        </Col>
      </Row>
      <Row className="mt-5 pt-5">
        <Col className="mt-5">
          <p>Datos personales</p>
          <p><small>
            Para garantizar el cumplimiento de la normativa vigente 2016/679 de 27 de abril de 2016, 
            sobre protección de datos de carácter personal, te informamos de que los datos que nos facilitas 
            serán tratados por Fundación Banco de Alimentos de Granada, Ctra. de Córdoba s/n, 18015 Granada, 
            exclusivamente para mantener el contacto, informar sobre novedades y mejorar el servicio. 
            Puedes ejercer los derechos de acceso, rectificación, cancelación y oposición al tratamiento de tus datos de 
            carácter personal, dirigiendo tu petición a la dirección postal antes mencionada o al correo electrónico 
            <a href="mailto:fundacion@bancoalimentosgranada.org">fundacion@bancoalimentosgranada.org</a>. Consulta nuestra política de privacidad en <a href="www.bancoalimentosgranada.org">www.bancoalimentosgranada.org</a>.
          </small></p>
        </Col>
      </Row>
    </div>
  );
}
export default Landing;
